// frontend/src/theme.js
// Controla o tema claro/escuro do app. 'system' segue prefers-color-scheme
// (comportamento padrão do index.css); 'light'/'dark' fixam via [data-theme].
const STORAGE_KEY = 'argus-theme';

export function getStoredTheme() {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === 'light' || stored === 'dark' ? stored : 'system';
}

export function applyTheme(theme) {
    const root = document.documentElement;
    if (theme === 'light' || theme === 'dark') {
        root.setAttribute('data-theme', theme);
    } else {
        root.removeAttribute('data-theme');
    }
}

export function setTheme(theme) {
    if (theme === 'system') {
        localStorage.removeItem(STORAGE_KEY);
    } else {
        localStorage.setItem(STORAGE_KEY, theme);
    }
    applyTheme(theme);
}
